import React from 'react'
import styles from './LoggedInBlock.module.css'
import Button from '../Button/Button'

class LoggedInBlock extends React.Component {
    deleteCookie = name => {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    }

    handleClick = clickStuff => {
        this.deleteCookie('persist%3Aroot')
        this.deleteCookie('reduxPersistIndex')
        this.props.logout()
    }

    userInitials = (firstName, lastName) => {
        if (firstName && lastName) {
            return `${firstName.charAt(0)}${lastName.charAt(0)}`
        }
        return 'NN'
    }

    render() {
        return (
            <div className={styles.loggedInWrap}>
                {this.props.user.photo ? (
                    <img
                        src={`https://app.beapplied.com${
                            this.props.user.photo
                        }`}
                        className={styles.userImage}
                        alt="user"
                    />
                ) : (
                    <div className={styles.userInitials}>
                        {this.userInitials(
                            this.props.user.firstName,
                            this.props.user.lastName,
                        )}
                    </div>
                )}
                <div className={styles.name}>{`${this.props.user.firstName ||
                    this.props.user.email ||
                    ''} ${this.props.user.lastName || ''}`}</div>
                <div
                    className={styles.buttonShove}
                    onClick={() => this.handleClick({})}
                >
                    <Button hollow>Logout</Button>
                </div>
            </div>
        )
    }
}

export default LoggedInBlock
